import React from 'react';
import TextField from 'material-ui/TextField';

function clearNumberString(str, canBeNegative, floatNumber) {
    const code0 = '0'.charCodeAt(0);
    const code9 = '9'.charCodeAt(0);
    let dst = '';
    let aDigitBefore = false;
    let aDotBefore = false;
    for (let i = 0; i < str.length; i++) {
        let code = str.charCodeAt(i);
        if (
            (canBeNegative && i === 0 && str[i] === '-') ||
            (floatNumber && aDigitBefore && !aDotBefore && str[i] === '.') ||
            (code >= code0 && code <= code9)
        ) {
            dst += str[i];
            // Legacy equivalent of ||= operator
            aDigitBefore = code >= code0 && code <= code9 ? true : aDigitBefore;
            aDotBefore = str[i] === '.' ? true : aDotBefore;
        }
    }
    return dst;
}

/** @param {{ canBeNegative?: boolean, floatNumber?: boolean, [key: string]: any }} props */
export default function NumberField({ canBeNegative, floatNumber, ...props }) {
    return (
        <TextField
            {...props}
            type="text"
            onChange={(e, ...rest) => {
                if (e.target.value.length > 0) {
                    const strValue = clearNumberString(e.target.value, canBeNegative, floatNumber);
                    if (strValue !== e.target.value) {
                        e.target.value = strValue;
                        props.onChange && props.onChange(e, strValue);
                        return;
                    }
                }
                props.onChange && props.onChange(e, ...rest);
            }}
        />
    );
}



// WEBPACK FOOTER //
// ./app/components/Base/NumberField/index.jsx